import React, { useState } from 'react';
import { saveCategory } from '../../../services/categories.js';
import { uploadImageS3 } from '../../../services/file.js';
import Input from '../../../components/Input';
import TextField from '../../../components/TextField';
import FileInput from '../../../components/Input/fileInput.js';
import { Box, Button } from '@mui/material';
import { useAlert } from '../../../context';

const CategoryForm = ({ setShowCategoryModal }) => {
  const [states, setStates] = useState({
    slug: '',
    description: '',
    background_url: '',
    loadingImage: false,
    imageFileName: '',
  });

  const { setShowError, setShowSuccess, setTextSuccessAlert } = useAlert();

  const handleChange = field => e =>
    setStates(prev => ({ ...prev, [field]: e.target.value }));

  const handleImageUpload = e => {
    e.preventDefault();
    setStates(prev => ({ ...prev, loadingImage: true }));
    uploadImageS3(e).then(data => {
      if (data) {
        setStates(prev => ({
          ...prev,
          loadingImage: false,
          background_url: data.location,
          imageFileName: data.key,
        }));
      } else {
        setStates(prev => ({ ...prev, loadingImage: false }));
        setShowError(true);
      }
    });
  };

  const handleSaveCategory = () => {
    saveCategory({ slug: states.slug, description: states.description, background_url: states.background_url }).then(
      () => {
        setShowSuccess(true);
        setTextSuccessAlert('Categoria criada com sucesso');
        setShowCategoryModal(prev => ({ ...prev, showCategoryModal: false }));
        setTimeout(() => window.location.reload(), 1400);
      },
      () => {
        setShowError(true);
        setShowCategoryModal(prev => ({ ...prev, showCategoryModal: false }));
      }
    );
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <Input
        required
        type="text"
        id="category-title"
        name="category-title"
        label="Título"
        value={states.slug}
        onKeyDown={e => e.key === 'Enter' && handleSaveCategory()}
        onChange={handleChange('slug')}
      />
      <TextField
        label="Descrição"
        value={states.description}
        onChange={handleChange('description')}
      />
      <Box>
        <Box component="label" sx={{ fontSize: '13px', fontWeight: 500, color: '#49454F', display: 'block', mb: '6px' }}>
          Foto de fundo do card <Box component="span" sx={{ fontSize: '11px', color: '#9e9e9e', fontWeight: 400 }}>(imagem exibida no card da categoria)</Box>
        </Box>
        <FileInput
          loading={states.loadingImage}
          fileName={states.imageFileName || (states.background_url ? 'Imagem carregada' : '')}
          onChange={handleImageUpload}
        />
      </Box>
      <Button
        type="button"
        variant="contained"
        className="btns"
        onClick={handleSaveCategory}
        sx={{
          alignSelf: 'end',
          fontWeight: 600,
          width: '150px',
          height: '44px',
          borderRadius: '10px',
          backgroundColor: 'primary.main',
          margin: '8px 16px 0',
        }}
      >
        Salvar
      </Button>
    </Box>
  );
};

export default CategoryForm;
